import suiteService from 'qreventos-suite/services';
import invitacionService from 'qreventos-suite/invitaciones';

class SuiteConfig {
    evento:number = 902;
    token:string = 'bUJldXJDYnNJRVdFdVVCL3FnbmI4STNneDZuYncvaUZnVTl4cU9kQjlXaz0=';
    clientId: string = '9a3c7dd6-fa35-44c2-9096-06bdf902b8fc-902';

    public constructor() {
      suiteService.clientId = this.clientId;
      suiteService.token = this.token;  

      invitacionService.clientId = this.clientId;
      invitacionService.token = this.token;
    }
}

export default new SuiteConfig();
